import { $isTextNode, DOMConversionMap, DOMConversionOutput, LexicalNode } from 'lexical';

// overrides core Lexical <span> loading, includes fontSize 
function convertSpanElement(domNode: HTMLElement): DOMConversionOutput {
  const fontSize = (domNode as HTMLSpanElement).style.fontSize;

  return {
    forChild: (lexicalNode: LexicalNode) => {
      if ($isTextNode(lexicalNode) && fontSize) {
        lexicalNode.setStyle(`font-size: ${fontSize}`);
      }
      return lexicalNode;
    },
    node: null
  };
}

export const htmlImportOverrides: DOMConversionMap = {
  span: () => ({ conversion: convertSpanElement, priority: 1 }),
};
